
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users",
      function () {
        return require("private-next-pages/users/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users"])
      });
    }
  